export enum NOTIFICATION_STATUS {
  NotDisplayed = 1,
  Displayed = 2,
  Done = 3,
}

export enum NOTIFICATION_TYPE {
  CreateArtist = 100,
  UpdateArtist = 101,
  DeleteArtist = 102,

  CreateTrack = 200,
  UpdateTrack = 201,
  DeleteTrack = 202,
  CreateTrackTitle = 203,
  UpdateTrackTitle = 204,
  DeleteTrackTitle = 205,
  AddArtistToTrack = 206,
  UpdateArtistTrack = 207,
  RemoveArtistFromTrack = 208,

  CreateMusicProductDigital = 300,
  UpdateMusicProductDigital = 301,
  DeleteMusicProductDigital = 302,

  CreateDelivery = 400,
  UpdateDelivery = 401,
  DeleteDelivery = 402,

  CreateSalesChannel = 500,
  UpdateSalesChannel = 501,
  DeleteSalesChannel = 502,

  CreateLabel = 600,
  UpdateLabel = 601,
  DeleteLabel = 602,
  LabelChangedStatusToCompleted = 603,

  CreateStatement = 700,

  CreateAgreementTemplate = 800,
  UpdateAgreementTemplate = 801,
  DeleteAgreementTemplate = 802,

  CreateContractTemplate = 900,
  UpdateContractTemplate = 901,
  DeleteContractTemplate = 902,

  CreateCustomSectionTemplate = 1000,
  UpdateCustomSectionTemplate = 1001,
  DeleteCustomSectionTemplate = 1002,

  CreateDigitalDistributionSectionTemplate = 1100,
  UpdateDigitalDistributionSectionTemplate = 1101,
  DeleteDigitalDistributionSectionTemplate = 1102,

  CreateUserConfiguration = 1200,
  CreateLicenceConfiguration = 1201,

  CreateContract = 1300,
  UpdatedContract = 1301,
  ContractActivated = 1302,
  ContractWithdrawn = 1303,

  CreateChannel = 1101,
  UpdatedChannel = 1102,
  DeletedChannel = 1103,
}

export enum NOTIFICATION_CATEGORY {
  Releases = 1,
  Labels = 2,
  Contracts = 3,
  Youtube = 4,
  Settlements = 5,
  Statements = 6,
  Deliveries = 7,
  LabelReports = 8,
  Artists = 9,
  Tracks = 10,
  Errors = 11,
  SmartLinks = 12,
  Configurations = 13,
  MusicProductDigital = 14,
  SalesChannel = 15,
  Contract = 16,
  Channel = 17,
  Video = 18,
  Merch = 19,
  Provider = 20,
  MusicProductPhysical = 21,
  Default = -1,
}
